import { decryptData } from "./decryptData";

export function getCurrentUserModules() {
  return decryptData(localStorage.getItem('mirror'), process.env.REACT_APP_THE_WORD);
}

